export default __webpack_public_path__ + "static/media/buy_gmx.0a68fcff.svg";